module.exports = __webpack_public_path__ + "img/credential-logo-niice.f5af46b026392b22b01a4d3b14185744.svg";